import Image from "next/image";
import { twMerge } from "tailwind-merge";
import Flex from "../flex/Flex";

type LoadingAnimationProps = {
  height?: number;
  width?: number;
  className?: string;
};

/**
 * Displays image with andercore loading gif (A_2a.gif - Andercore loading gif) at the center of the screen
 * @param height - height of the loading animation
 * @param width - width of the loading animation
 * @returns LoadingAnimation component with the loading animation
 */
const AndercoreLogoLoadingGif = ({ height = 60, width = 60, className }: LoadingAnimationProps) => {
  return (
    <Flex className={twMerge("w-full h-screen justify-center items-center bg-gray-50", className)}>
      <Image src="/images/A_2a.gif" alt="" width={width} height={height} unoptimized loading="eager" />
    </Flex>
  );
};

export default AndercoreLogoLoadingGif;
